import { render, staticRenderFns } from "./LegalPreview.vue?vue&type=template&id=7da7bddc&scoped=true&"
import script from "./LegalPreview.vue?vue&type=script&lang=js&"
export * from "./LegalPreview.vue?vue&type=script&lang=js&"
import style0 from "./LegalPreview.vue?vue&type=style&index=0&id=7da7bddc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da7bddc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
